import React from "react";

function ViewPanel({ children: { content, actions } }) {
  const panelStyle = { display: "flex", flexDirection: "column", width: "100%", marginLeft: 10 };
  const contentStyle = { flex: 1, paddingBottom: 10 };

  return (
    <div style={panelStyle}>
      <div style={contentStyle}>{content}</div>
      {actions}
    </div>
  );
}

export default ViewPanel;
